<template>
  <div>
    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>Filter Location</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="12" class="mb-md-0 mb-2">
            <location-filters size="sm" align="horizontal" @filter="changeFilter" />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- ./Filters -->

    <section>
      <b-card no-body>
        <b-row class="match-height">
          <b-col lg="12" md="12">
            <!-- <line-series-chart /> -->
            <bar-chart :location_id="location_id" />
          </b-col>
          <!-- <b-col lg="4" md="4">
            <ecommerce-goal-overview :data="data.goalOverview" />
          </b-col> -->
        </b-row>
      </b-card>
    </section>

    <section id="dashboard-ecommerce">
      <b-card no-body class="card-statistics">
        <b-card-header>
          <b-card-title>Daily Purchases</b-card-title>
          <b-card-text class="font-small-2 mr-15 mb-0"> </b-card-text>
        </b-card-header>

        <b-card-body class="statistics-body">
          <b-row>
            <b-col cols="4">
              <b-form-group label-for="Aa Of" label="As Of">
                <b-form-datepicker
                  @input="changeDate"
                  v-model="cutOffDate"
                  size="sm"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  locale="en"
                />
              </b-form-group>
            </b-col>

            <b-col cols="8">
              <div class="d-flex justify-content-end mt-10" style="margin-top: 24px">
                <b-button variant="outline-success" size="sm" @click="download(true)">
                  <span class="text-nowrap">Download</span>
                  <feather-icon icon="FileTextIcon" class="ml-1" />
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-col cols="12">
            <daily-purchases :data="purchases" />
          </b-col>
        </b-card-body>
      </b-card>

      <!-- <b-row>
        <b-col lg="12">
          <ecommerce-revenue-report :data="data.revenue" />
        </b-col>
      </b-row> -->
    </section>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BPagination,
  BCardTitle,
  BForm,
  BFormGroup,
  BCardText,
  BFormDatepicker,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import LocationFilters from "@core/components/cromis/filters/LocationFilters";
import EcommerceMedal from "./EcommerceMedal.vue";
import GrowersStatistics from "./GrowersStatistics.vue";
import DailyPurchases from "./DailyPurchases.vue";
import EcommerceRevenueReport from "./EcommerceRevenueReport.vue";
import LineSeriesChart from "./LineSeriesChart.vue";
import BarChart from "./BarChart.vue";
import EcommerceProfitChart from "./EcommerceProfitChart.vue";
import EcommerceEarningsChart from "./EcommerceEarningsChart.vue";
import EcommerceCompanyTable from "./EcommerceCompanyTable.vue";
import EcommerceMeetup from "./EcommerceMeetup.vue";
import EcommerceBrowserStates from "./EcommerceBrowserStates.vue";
import EcommerceGoalOverview from "./EcommerceGoalOverview.vue";
import EcommerceTransactions from "./EcommerceTransactions.vue";
import { ref, onUnmounted, onMounted, watch } from "@vue/composition-api";
import useLineSeriesStoreModule from "@/views/dashboard/ecommerce/useLineSeriesStoreModule";
import store from "@/store";
import axios from "@axios";

export default {
  props: {},
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BPagination,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BButton,
    BSpinner,

    EcommerceMedal,
    GrowersStatistics,
    DailyPurchases,
    EcommerceRevenueReport,
    LineSeriesChart,
    BarChart,
    EcommerceProfitChart,
    EcommerceEarningsChart,
    EcommerceCompanyTable,
    EcommerceMeetup,
    EcommerceBrowserStates,
    EcommerceGoalOverview,
    EcommerceTransactions,
    LocationFilters,
    BFormDatepicker,
  },
  directives: {},

  setup(props, context) {
    const data = ref({})
    const growers = ref({})
    const purchases = ref({})
    const cutOffDate = ref(null)
    const location_id = ref(null)
    const user = ref(JSON.parse(localStorage.getItem("userData")))

    const CROMIS_STORE_MODULE_NAME = "cromis-daily-purchase";
    // Register module
    if (!store.hasModule(CROMIS_STORE_MODULE_NAME))
      store.registerModule(CROMIS_STORE_MODULE_NAME, useLineSeriesStoreModule);

    onMounted(async () => {
      // data
      await store
        .dispatch("cromis-daily-purchase/dailyPurcahse", {
          location_id: location_id.value,
          cutOffDate: cutOffDate.value,
        })
        .then((response) => {
          purchases.value = response.data;
          console.log(purchases.value);
        })
        .catch((error) => {
          console.log("got error", error);
          loading.value = false;
        });

      growers.value = [
        {
          icon: "UsersIcon",
          color: "light-info",
          title: "889",
          subtitle: "Farmers",
          customClass: "mb-2 mb-xl-0",
        },
        {
          icon: "GlobeIcon",
          color: "light-danger",
          title: "6",
          subtitle: "Regions",
          customClass: "mb-2 mb-sm-0",
        },
        {
          icon: "CodesandboxIcon",
          color: "light-success",
          title: "120",
          subtitle: "Areas",
          customClass: "",
        },
      ];
    });

    const changeFilter = async (location) => {
      location_id.value = location !== null ? location.id : null;
      await store
        .dispatch("cromis-daily-purchase/dailyPurcahse", {
          location_id: location_id.value,
          cutOffDate: cutOffDate.value,
        })
        .then((response) => {
          purchases.value = response.data;
          console.log(purchases.value);
        })
        .catch((error) => {
          console.log("got error", error);
          loading.value = false;
        });
    };

    const changeDate = async () => {
      await store
        .dispatch("cromis-daily-purchase/dailyPurcahse", {
          location_id: location_id.value,
          cutOffDate: cutOffDate.value,
        })
        .then((response) => {
          purchases.value = response.data;
        })
        .catch((error) => {
          console.log("got error", error);
          loading.value = false;
        });
    };

    const download = async () => {
      window.open(
        `${axios.defaults.baseURL}/reports/daily_purchases?report_id=${user.value.id}&data_type=2&location_id=${location_id.value}&cutOffDate=${cutOffDate.value}`,
        "_blank"
      );
    };

    return {
      purchases,
      data,
      growers,
      location_id,
      cutOffDate,
      changeFilter,
      changeDate,
      download,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
